export default __webpack_public_path__ + "static/media/flag-tunisia.4440d498.svg";